import { Package, CreditCard, Building2, Banknote, HandCoins, SplitSquareHorizontal } from "lucide-react";
import { fileUrl } from "@/lib/api";
import { cn } from "@/lib/utils";
import { Badge } from "@/components/ui/badge";
import { PAY_LABEL, paymentsSummary } from "@/lib/pos";

// Hızlı Satış küçük görsel parçaları — sayfa + pos/* diyalogları ortak kullanır
export const IMG = ({ src, alt, className = "h-12 w-12" }) => {
  const s = fileUrl(src || "");
  return s ? (
    <img src={s} alt={alt} loading="lazy" decoding="async" className={`${className} rounded-md object-contain bg-white border shrink-0`} />
  ) : (
    <div className={`${className} rounded-md border bg-muted flex items-center justify-center shrink-0`}><Package className="h-5 w-5 text-muted-foreground" /></div>
  );
};

export const HeroKpi = ({ label, value, sub, icon: Icon, accent, testid }) => (
  <div className="rounded-2xl border border-white/10 bg-white/5 px-4 py-3 backdrop-blur-sm" data-testid={testid}>
    <div className="flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-[0.16em] text-white/50">{Icon && <Icon className="h-3.5 w-3.5" />}{label}</div>
    <div className={cn("font-head font-black tnum leading-none mt-1.5 text-2xl", accent ? "text-[#FF8A4C]" : "text-white")}>{value}</div>
    <div className="text-[10px] text-white/40 mt-1">{sub}</div>
  </div>
);

export const Stat2 = ({ label, value, accent, testid }) => (
  <div className="rounded-lg bg-slate-50 px-2.5 py-1.5" data-testid={testid}>
    <div className="text-[9px] font-bold uppercase tracking-wider text-muted-foreground">{label}</div>
    <div className={cn("font-head font-black tnum text-base leading-tight mt-0.5", accent ? "text-emerald-600" : "text-slate-800")}>{value}</div>
  </div>
);

export const PayBadge = ({ m, paid = false, parts = null }) => (
  <Badge variant="outline" title={m === "karma" && parts ? paymentsSummary(parts) : undefined} className={cn("gap-1 text-[10px]", m === "kredi_karti" ? "border-blue-200 text-blue-700 bg-blue-50" : m === "havale" ? "border-violet-200 text-violet-700 bg-violet-50" : m === "veresiye" ? (paid ? "border-emerald-300 text-emerald-700 bg-emerald-50" : "border-amber-300 text-amber-800 bg-amber-50") : m === "karma" ? "border-sky-300 text-sky-800 bg-sky-50" : "border-emerald-200 text-emerald-700 bg-emerald-50")} data-testid="qs-pay-badge">
    {m === "kredi_karti" ? <CreditCard className="h-3 w-3" /> : m === "havale" ? <Building2 className="h-3 w-3" /> : m === "veresiye" ? <HandCoins className="h-3 w-3" /> : m === "karma" ? <SplitSquareHorizontal className="h-3 w-3" /> : <Banknote className="h-3 w-3" />}
    {m === "karma" && parts ? `Karma · ${paymentsSummary(parts)}` : PAY_LABEL[m] || "Nakit"}{m === "veresiye" && paid ? " · Tahsil edildi" : ""}
  </Badge>
);
